import {
  Box,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableHead
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import { CustomLineProgress } from "components/LineProgress";

import { BodyCell, BodyRow, HeadCell, TableContent } from "../../style";

export const SubCategoriesTable = ({
  subcategoriesData,
  loading,
  handleOpenUpdate
}) => {
  return (
    <Box>
      {!!loading && <CustomLineProgress />}
      <TableContent component={Paper}>
        <Table stickyHeader>
          <TableHead>
            <HeadCell>ID</HeadCell>
            <HeadCell>Subcategoria</HeadCell>
            <HeadCell>Categoria</HeadCell>
            <HeadCell>Estoque</HeadCell>
            <HeadCell>Sigla</HeadCell>
            <HeadCell></HeadCell>
          </TableHead>
          <TableBody>
            {subcategoriesData?.map(subcategory => (
              <BodyRow key={subcategory.id}>
                <BodyCell>{subcategory.id}</BodyCell>
                <BodyCell>{subcategory.name}</BodyCell>
                <BodyCell>{subcategory.productCategory?.name}</BodyCell>
                <BodyCell>{subcategory.storageStockType?.name}</BodyCell>
                <BodyCell>{subcategory.abbreviation?.toUpperCase()}</BodyCell>
                <BodyCell>
                  <IconButton onClick={() => handleOpenUpdate(subcategory.id)}>
                    <EditIcon />
                  </IconButton>
                </BodyCell>
              </BodyRow>
            ))}
          </TableBody>
        </Table>
      </TableContent>
    </Box>
  );
};
